import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-729c0b32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content1" }
const _hoisted_2 = { class: "information" }
const _hoisted_3 = { style: {"display":"flex"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "username" }, "用户名", -1))
const _hoisted_5 = { class: "usernameinput" }
const _hoisted_6 = { style: {"display":"flex"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "phone" }, "手机号", -1))
const _hoisted_8 = { class: "number" }
const _hoisted_9 = { style: {"display":"flex"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "name" }, "姓名", -1))
const _hoisted_11 = { class: "nameinput" }
const _hoisted_12 = {
  key: 0,
  class: "self"
}
const _hoisted_13 = {
  key: 1,
  class: "selfs"
}
const _hoisted_14 = { style: {"display":"flex"} }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "companyname" }, "公司名称", -1))
const _hoisted_16 = { class: "companynameinput" }
const _hoisted_17 = {
  key: 0,
  class: "firm"
}
const _hoisted_18 = {
  key: 1,
  class: "selfs"
}
const _hoisted_19 = {
  key: 0,
  class: "selfs"
}
const _hoisted_20 = { style: {"display":"flex"} }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profession" }, "职业", -1))
const _hoisted_22 = { class: "list" }
const _hoisted_23 = { style: {"display":"flex"} }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tool" }, "常用软件", -1))
const _hoisted_25 = { class: "toolname" }
const _hoisted_26 = { class: "p1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.userinfot.username ? _ctx.userinfot.username : "未填写"), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.userinfot.mobile ? _ctx.userinfot.mobile : "未填写"), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.getInformation.data.name ? _ctx.getInformation.data.name : "未填写"), 1),
        _createVNode(_component_router_link, { to: "/user/selfverify" }, {
          default: _withCtx(() => [
            (
              _ctx.getInformation.data.identification != 3 &&
              _ctx.getInformation.data.pid == 0
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, " 个人认证>> "))
              : _createCommentVNode("", true),
            (
              _ctx.getInformation.data.identification == 3 &&
              _ctx.getInformation.data.pid == 0
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, " 已个人认证 "))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.getInformation.data.company ? _ctx.getInformation.data.company : "未填写"), 1),
        _createVNode(_component_router_link, { to: "/user/firmverify" }, {
          default: _withCtx(() => [
            (
              _ctx.getInformation.data.company_id == null &&
              _ctx.getInformation.data.pid == 0
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, " 企业认证>> "))
              : _createCommentVNode("", true),
            (
              _ctx.getInformation.data.company_id != null &&
              _ctx.getInformation.data.pid == 0
            )
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, " 已企业认证 "))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (
            _ctx.getInformation.data.company_id != null &&
            _ctx.getInformation.data.pid != 0
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, " 已企业认证 "))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.getInformation.data.vocation
              ? _ctx.getInformation.data.vocation
              : "未填写"), 1)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.getInformation.data.software
                ? _ctx.getInformation.data.software
                : "未选择"), 1)
        ])
      ])
    ]),
    _createElementVNode("button", {
      class: "submit routine",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeInformation && _ctx.changeInformation(...args)))
    }, "修改信息")
  ]))
}